module.exports = __webpack_public_path__ + "static/media/elephant.301d878a.svg";